import {Component} from '@angular/core';
import {CustomerFormComponent} from "../../../../forms/customer-form/customer-form.component";
import {MdbButtonComponent} from "../../../../utils/mdb-button/mdb-button.component";
import {AConcreteResource} from "../../../../AConcreteResource";
import {CustomerModel} from "../../../../../models/resources/customer.model";
import {FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {CustomerService} from "../../../../../services/resources/customer.service";
import {HttpErrorsService} from "../../../../../services/utils/http-errors.service";
import {CustomNotificationService} from "../../../../../services/utils/custom-notification.service";
import {SafeUpdateService} from "../../../../../services/utils/safe-update.service";
import {finalize} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {CompanyType} from "../../../../../enums/company-type";

@Component({
  selector: 'app-customer-data',
  imports: [
    CustomerFormComponent,
    MdbButtonComponent
  ],
  templateUrl: './customer-data.component.html',
  styleUrl: './customer-data.component.scss',
})
export class CustomerDataComponent extends AConcreteResource<CustomerModel> {
  loading: boolean = false
  formGroup: FormGroup | undefined

  constructor(
    router: Router,
    private customerService: CustomerService,
    private httpErrorsService: HttpErrorsService,
    private notificationService: CustomNotificationService,
    private safeUpdateService: SafeUpdateService
  ) {
    super(router, customerService);
    this.customerService.getAll({ paginated: false });
  }

  submit(serverResource: any = null, overrideValues: { [key: string]: any } = {}) {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = this.formGroup?.value;

    // Bei Person nur die erlaubten Felder aktualisieren – company, companyRegistry, erpIndustryId vom bestehenden Modell übernehmen
    if (resource.companyType === CompanyType.PERSON && this.model()) {
      resource.company = this.model()!.company;
      resource.companyRegistry = this.model()!.companyRegistry ?? null;
      resource.erpIndustryId = this.model()!.erpIndustryId ?? null;
    }

    // for safe update
    resource.updatedAt = this.model()!.updatedAt
    resource.person.id = this.model()!.person?.id
    resource.person.updatedAt = this.model()!.person?.updatedAt
    if (this.model()?.address?.id) {
      resource.address.id = this.model()!.address.id
      resource.address.updatedAt = this.model()!.address.updatedAt
    }
    if (this.model()?.person?.id) {
      if (!resource.person.name &&
        !resource.person.phoneNumber &&
        !resource.person.email) {
        resource.person.deleted = true;
      }
    } else {
      if (!resource.person.name &&
        !resource.person.phoneNumber &&
        !resource.person.email)
        resource.person = null;
    }

    if (resource.parent)
      resource.parentId = resource.parent.id;

    if (serverResource)
      resource = this.safeUpdateService.handleResource(resource, serverResource, overrideValues)

    this.customerService
      .update(this.model()!.id, resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.notificationService.success('CHANGES_SUCCESSFULLY_SAVED');
        },
        error: (e: HttpErrorResponse) => {
          this.httpErrorsService.handleError(e, (newServerResource, newOverrideValues) => {
            this.submit(newServerResource, newOverrideValues);
          })
        },
      });
  }
}
